import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonModule } from 'primeng/button';
import { ImprimirInformeCabeceraComponent } from './imprimir-informe-cabecera.component';





@NgModule({
    declarations: [
      ImprimirInformeCabeceraComponent
    ],
    imports: [ 
        CommonModule,
        ButtonModule 
    ],
    exports: [  ImprimirInformeCabeceraComponent],
    providers: [],
})
export class ImprimirInformeCabeceraSharedModule {}